import {languageList, useTranslation} from '@pancakeswap/localization'
import {footerLinks, Menu as UikitMenu, NextLinkFromReactRouter, ThemeSwitcher, useModal} from '@pancakeswap/uikit'
import USCitizenConfirmModal from 'components/Modal/USCitizenConfirmModal'
import {NetworkSwitcher} from 'components/NetworkSwitcher'
// import PhishingWarningBanner from 'components/PhishingWarningBanner'
// import { useCakeBusdPrice } from 'hooks/useBUSDPrice'
import useTheme from 'hooks/useTheme'
import {useRouter} from 'next/router'
import {useMemo} from 'react'
import {useActiveChainId} from 'hooks/useActiveChainId'
import {usePhishingBanner} from '@pancakeswap/utils/user'
import {IdType} from 'hooks/useUserIsUsCitizenAcknowledgement'
import {usePriceCakeUSD} from 'state/farms/hooks'
// import GlobalSettings from './GlobalSettings'
// import { SettingsMode } from './GlobalSettings/types'
import Faucet from "components/Faucet";
import {ChainId} from "@pancakeswap/sdk";
import {useMenuItems} from './hooks/useMenuItems'
import UserMenu from './UserMenu'
import {getActiveMenuItem, getActiveSubMenuItem} from './utils'

const LinkComponent = (linkProps) => {
  return <NextLinkFromReactRouter to={linkProps.href} {...linkProps} prefetch={false} />
}

const Menu = (props) => {
  const { chainId } = useActiveChainId()
  const { isDark, setTheme } = useTheme()
  const cakePriceUsd = usePriceCakeUSD(chainId)
  const { currentLanguage, setLanguage, t } = useTranslation()
  const { pathname } = useRouter()
  const [onUSCitizenModalPresent] = useModal(
    <USCitizenConfirmModal title={t('PancakeSwap Perpetuals')} id={IdType.PERPETUALS} />,
    false,
    false,
    'usCitizenConfirmModal',
  )
  const [showPhishingWarningBanner] = usePhishingBanner()

  const menuItems = useMenuItems(onUSCitizenModalPresent)

  const activeMenuItem = getActiveMenuItem({ menuConfig: menuItems, pathname })
  const activeSubMenuItem = getActiveSubMenuItem({ menuItem: activeMenuItem, pathname })

  const toggleTheme = useMemo(() => {
    return () => setTheme(isDark ? 'light' : 'dark')
  }, [setTheme, isDark])

  const getFooterLinks = useMemo(() => {
    return footerLinks(t)
  }, [t])

  return (
    <>
      <UikitMenu
        linkComponent={LinkComponent}
        rightSide={
          <>
            {/* <GlobalSettings mode={SettingsMode.GLOBAL} /> */}
            {/* eslint-disable-next-line eqeqeq */}
            {chainId == ChainId.BASE_GOERLI && (
              <Faucet />
            )}
            <ThemeSwitcher isDark={isDark} toggleTheme={() => setTheme(isDark ? 'light' : 'dark')} />
            <NetworkSwitcher />
            <UserMenu />
          </>
        }
        chainId={chainId}
        // banner={showPhishingWarningBanner && typeof window !== 'undefined' && <PhishingWarningBanner />}
        isDark={isDark}
        toggleTheme={toggleTheme}
        currentLang={currentLanguage.code}
        langs={languageList}
        setLang={setLanguage}
        cakePriceUsd={cakePriceUsd.toNumber()}
        links={menuItems}
        subLinks={activeMenuItem?.hideSubNav || activeSubMenuItem?.hideSubNav ? [] : activeMenuItem?.items}
        footerLinks={getFooterLinks}
        activeItem={activeMenuItem?.href}
        activeSubItem={activeSubMenuItem?.href}
        buyCakeLabel={t('Buy DACKIE')}
        buyCakeLink=""
        {...props}
      />
    </>
  )
}

export default Menu
